import { useUserStore } from "@/stores/react/authStore";

export interface DeviceClaimActionAccessOptions {
    permissions?: string[];
    banButton?: boolean;
}

/** 统一设备认领处理入口的写权限与按钮封禁状态，保持 Vue v-auth 语义一致。 */
export function useDeviceClaimActionAccess({ permissions, banButton }: DeviceClaimActionAccessOptions = {}) {
    const storePermissions = useUserStore(state => state.userInfo.permissions || []);
    const storeBanButton = useUserStore(state => state.banButton);

    return {
        canBind: (permissions ?? storePermissions).includes("ROLE_DEVICE_BIND_W"),
        isButtonBanned: banButton ?? storeBanButton
    };
}
